export default "__VITE_PUBLIC_ASSET__709dfdd3__"